namespace GeniuzPOS.PosShift {
    export interface PsEndDayCashierForm {
        StartShift: Serenity.IntegerEditor;
        EndShift: Serenity.IntegerEditor;
        CashierId: Serenity.StringEditor;
        ShopId: Serenity.StringEditor;
        CreateDate: Serenity.DateEditor;
        CashBag: Serenity.DecimalEditor;
        StartCountId: Serenity.IntegerEditor;
        EndCountId: Serenity.IntegerEditor;
        Amt: Serenity.DecimalEditor;
    }

    export class PsEndDayCashierForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.PsEndDayCashier';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsEndDayCashierForm.init)  {
                PsEndDayCashierForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(PsEndDayCashierForm, [
                    'StartShift', w0,
                    'EndShift', w0,
                    'CashierId', w1,
                    'ShopId', w1,
                    'CreateDate', w2,
                    'CashBag', w3,
                    'StartCountId', w0,
                    'EndCountId', w0,
                    'Amt', w3
                ]);
            }
        }
    }
}
